import type * as React from 'react'
import { Dialog, Button } from '@buffer-mono/popcorn'

import UpgradePath from '~publish/legacy/upgrade-paths'
import { CTA_CLICKED, sendPaywallEvent } from './tracking'
import { useCommonTrackingProperties } from '~publish/hooks/useCommonTrackingProperties'

import styles from './PaywallModal.module.css'

type PayWallProps = {
  children: React.ReactNode | JSX.Element
  labelForCtaButton?: string
  cta: string
  upgradePathName: string
  ctaForUpgradePath: string
  ctaMPMigration: string
  onClosePaywall: () => void
}

const PayWallModal = ({
  children,
  labelForCtaButton = 'See Upgrade Options',
  cta,
  upgradePathName,
  ctaForUpgradePath,
  ctaMPMigration,
  onClosePaywall,
}: PayWallProps): JSX.Element => {
  const commonTrackingProps = useCommonTrackingProperties()

  /**
   * Manages the click event for the CTA button
   *
   * @param onUpgradeClick - method that opens the upgrade modal or migration hub
   * depending on if the user is a newBuffer user or not
   */
  const handleOnClick = (onUpgradeClick: any): void => {
    sendPaywallEvent(CTA_CLICKED, cta, upgradePathName, commonTrackingProps)
    onUpgradeClick({
      cta: ctaForUpgradePath,
      ctaMPMigration,
      upgradePathName,
    })
    onClosePaywall()
  }

  return (
    <Dialog open={true} onOpenChange={onClosePaywall}>
      <Dialog.Content size="small" className={styles.dialogContent}>
        <Dialog.CloseButton />
        <div className={styles.paywallWrapper}>
          <div className={styles.paywallContent} data-test-id="paywall-content">
            {children}
            <div className={styles.ctaContainer}>
              <UpgradePath>
                {(onUpgradeClick): JSX.Element => (
                  <Button
                    variant="primary"
                    onClick={(): void => handleOnClick(onUpgradeClick)}
                    className={styles.ctaButton}
                  >
                    {labelForCtaButton}
                  </Button>
                )}
              </UpgradePath>
            </div>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  )
}

export default PayWallModal
